import { Type } from "@sinclair/typebox";
import SchemaValidator from "../../schema-validator";

const proctoringSessionState = new SchemaValidator(
	Type.Object({
		status: Type.Union([Type.String(), Type.Undefined()]),
	}),
);

export default {
	proctoringSessionState,
};
